import { render } from "./MainButton.vue?vue&type=template&id=789331f4&scoped=true"
import script from "./MainButton.vue?vue&type=script&lang=js"
export * from "./MainButton.vue?vue&type=script&lang=js"

import "./MainButton.vue?vue&type=style&index=0&id=789331f4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-789331f4"

export default script